export const
  RBI = Object.freeze({
    name: 'RBI',
    domain: 'rbi.cityfalcon.com',
    pages: ['/search', '/watchlists']
  });
